var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery, useQueryClient } from "react-query";
import apiService from "../../services/api";
// Conversations change rarely while working the queue; reuse them for View Thread, Generate and the send notice
const CONVERSATION_STALE_TIME_MS = 5 * 60 * 1000;
export const getDealConversationQueryKey = (contactEmail) => ["deal-conversation", contactEmail];
/**
 * The thread with a lead and how a reply would be sent. Shared by the To Do cards and the review list, so a lead's
 * conversation is fetched once; the API queues these lookups to stay inside Instantly's rate limit.
 */
export const useDealConversation = (contactEmail, getAccessTokenSilently, isEnabled) => {
    const queryClient = useQueryClient();
    const queryKey = getDealConversationQueryKey(contactEmail);
    const fetchConversation = () => __awaiter(void 0, void 0, void 0, function* () {
        const token = yield getAccessTokenSilently();
        const { conversation } = yield apiService.getConversation(token, contactEmail);
        return conversation;
    });
    const query = useQuery(queryKey, fetchConversation, {
        enabled: !!contactEmail && isEnabled,
        staleTime: CONVERSATION_STALE_TIME_MS,
        retry: 1,
    });
    const loadConversation = () => queryClient.fetchQuery(queryKey, fetchConversation, {
        staleTime: CONVERSATION_STALE_TIME_MS,
    });
    const invalidateConversation = () => queryClient.invalidateQueries(queryKey);
    return Object.assign(Object.assign({}, query), { loadConversation, invalidateConversation });
};
